import { memo, useEffect, useRef, useState } from "react";
import type { FC } from "react";

import resets from "../_resets.module.css";
import { Button_StyleFilledSizeLBrand } from "./Button_StyleFilledSizeLBrand/Button_StyleFilledSizeLBrand";
import { Footer } from "./Footer/Footer";
import { GroupIcon } from "./GroupIcon";
import classes from "./Landing.module.css";
import { PlaceholderPicture } from "./PlaceholderPicture/PlaceholderPicture";
import { SectionText_AlignmentCenter } from "./SectionText_AlignmentCenter/SectionText_AlignmentCenter";
import Navbar from "./Navbar/Navbar";
import Carousel from "./carousel/Carousel";

interface Props {
  className?: string;
  hide?: {
    iconJamIconsOutlineLogosPlus?: boolean;
    caption?: boolean;
    mainHeadline?: boolean;
    paragraph?: boolean;
    caption2?: boolean;
    mainHeadline2?: boolean;
    paragraph2?: boolean;
    iconJamIconsOutlineLogosHome?: boolean;
    badge?: boolean;
    iconJamIconsOutlineLogosChevro?: boolean;
    iconJamIconsOutlineLogosHome2?: boolean;
    badge2?: boolean;
    iconJamIconsOutlineLogosChevro2?: boolean;
    iconJamIconsOutlineLogosHome3?: boolean;
    badge3?: boolean;
    iconJamIconsOutlineLogosChevro3?: boolean;
    iconJamIconsOutlineLogosHome4?: boolean;
    badge4?: boolean;
    iconJamIconsOutlineLogosChevro4?: boolean;
    menuItem?: boolean;
    menuItem2?: boolean;
    badge5?: boolean;
    iconJamIconsOutlineLogosPlus2?: boolean;
    iconJamIconsOutlineLogosHome5?: boolean;
    badge6?: boolean;
    iconJamIconsOutlineLogosChevro5?: boolean;
    iconJamIconsOutlineLogosHome6?: boolean;
    badge7?: boolean;
    iconJamIconsOutlineLogosChevro6?: boolean;
    iconJamIconsOutlineLogosHome7?: boolean;
    badge8?: boolean;
    iconJamIconsOutlineLogosChevro7?: boolean;
    iconJamIconsOutlineLogosHome8?: boolean;
    badge9?: boolean;
    iconJamIconsOutlineLogosChevro8?: boolean;
    iconJamIconsOutlineLogosHome9?: boolean;
    badge10?: boolean;
    iconJamIconsOutlineLogosChevro9?: boolean;
    menuItem3?: boolean;
  };
}
/* @figmaId 143:780 */

export const Landing: FC<Props> = memo(function Landing(props = {}) {
  const [showGroup, setShowGroup] = useState(true);
  const [showAllGallery, setShowAllGallery] = useState(false);

  const [buttonPositionFixed, setButtonPositionFixed] = useState(true);
  const whatsappButtonRef = useRef<HTMLAnchorElement>(null);
  const ctaRef = useRef<HTMLDivElement>(null);
  const emptyDivRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      setShowGroup(window.innerWidth > 1200); // Adjust the breakpoint as needed
    };

    const handleSmoothScroll = (e: Event) => {
      const target = e.target as HTMLElement;
      if (
        target.tagName === "A" &&
        target.getAttribute("href")?.startsWith("#")
      ) {
        e.preventDefault(); // Prevent default behavior of anchor links

        // Get target section id from href attribute
        const href = target.getAttribute("href");
        if (href) {
          const targetId = href.substring(1);

          // Scroll smoothly to the target section
          document.getElementById(targetId)?.scrollIntoView({
            behavior: "smooth",
          });
        }
      }
    };
    const handleScroll = () => {
      if (ctaRef.current && whatsappButtonRef.current && emptyDivRef.current) {
        const ctaPosition = ctaRef.current.getBoundingClientRect();
        const emptyDivPosition = emptyDivRef.current.getBoundingClientRect();

        if (emptyDivPosition.top > ctaPosition.top) {
          if (buttonPositionFixed) {
            setButtonPositionFixed(false); // Set to fixed position only if not already fixed
          }
        } else if (emptyDivPosition.top < ctaPosition.top) {
          // if (!buttonPositionFixed) {
          setButtonPositionFixed(true); // Set to relative position only if not already relative
          // }
        }
      }
    };

    handleResize(); // Check initial window width
    window.addEventListener("resize", handleResize); // Listen for window resize events
    window.addEventListener("click", handleSmoothScroll); // Listen for click events
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
      window.removeEventListener("click", handleSmoothScroll); // Cleanup
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Run once on component mount

  return (
    <div className={`${resets.storybrainResets} ${classes.root}`}>
      <Navbar />
      <div className={classes.hero}>
        <div className={classes.bG}></div>
        <div className={classes.frame33548}>
          <div className={classes.unnamed}>
            <div className={classes.textBlock}>
              התקנת עמדת טעינה
              <br /> לרכבים חשמליים
            </div>
          </div>
          <div className={classes._20}>
            <div className={classes.textBlock3} dir="rtl">
              יוסי שמש חשמלאי מוסמך מעל 20 שנים, מתמחה בהתקנת עמדות טעינה לרכבים
              חשמליים 
            </div>
          </div>
          <div className={classes.button3}>
            <Button_StyleFilledSizeLBrand
              className={classes.see}
              hide={{
                iconJamIconsOutlineLogosPlus: true,
              }}
              text={{
                buttonText: (
                  <div className={classes.buttonText}>
                    <a href="https://wa.me/972522459908?text=%D7%94%D7%99%D7%99%20%D7%99%D7%95%D7%A1%D7%99%2C%20%D7%90%D7%A0%D7%99%20%D7%9E%D7%A2%D7%95%D7%A0%D7%99%D7%99%D7%9F%20%D7%91%D7%A2%D7%9E%D7%93%D7%AA%20%D7%98%D7%A2%D7%99%D7%A0%D7%94%20%D7%9C%D7%A8%D7%9B%D7%91%20%D7%97%D7%A9%D7%9E%D7%9C%D7%99">
                      אני רוצה עמדת טעינה
                    </a>
                  </div>
                ),
              }}
            />
          </div>
        </div>
        {showGroup && (
          <div className={classes.group}>
            <GroupIcon className={classes.icon2} />
          </div>
        )}
        <div className={classes.image811}></div>
      </div>
      <div className={classes.whatWeDo} id="whatWeDo">
        <div className={classes.row}>
          <div className={classes.contentBox1}>
            <PlaceholderPicture className={classes.placeholderPicture} />
            <div className={classes.content}>
              <div className={classes.titleCategory}>
                <div className={classes.title}>בחניון</div>
                <div className={classes.subExampleText}>צריך עמדת טעינה בחניון? - אני עושה את זה.</div>
              </div>
            </div>
          </div>
          <div className={classes.contentBox2}>
            <PlaceholderPicture className={classes.placeholderPicture2} />
            <div className={classes.content2}>
              <div className={classes.titleCategory2}>
                <div className={classes.title2}>בבית</div>
                <div className={classes.subExampleText}>צריך עמדת טעינה בבית? - אני עושה את זה.</div>
              </div>
            </div>
          </div>
          <div className={classes.contentBox3}>
            <PlaceholderPicture className={classes.placeholderPicture3} />
            <div className={classes.content3}>
              <div className={classes.titleCategory3}>
                <div className={classes.title3}>בעסק</div>
                <div className={classes.subExampleText}>צריך עמדת טעינה בעסק? - אני עושה את זה.</div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.sectionText3}>
          <div className={classes.top3}>
            <div className={classes.secondaryHeadline3}>מה אני עושה</div>
          </div>
          <div className={classes.paragraph} dir="rtl">
            התקנת עמדות טעינה לרכב חשמלי לבית ולעסק בהתאמה אישית, עם שירות אמין, עבודה נקייה וליווי מלא עד ההפעלה. פתרונות חכמים לכל סוגי הרכבים והחניות - כדי שתטעינו בראש שקט, כל יום מחדש.
          </div>
        </div>
      </div>
      <div className={classes.pointsContainer} dir="rtl">
        <div className={classes.pointCard}>
          <div className={classes.pointIconWrapper}>
            <svg viewBox="0 0 24 24">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
            </svg>
          </div>
          <div className={classes.pointTitle}>התקנה מקצועית</div>
          <div className={classes.pointText}>
            חשמלאי מוסמך עובד לפי תקן בסטנדרט גבוה לשקט נפשי.
          </div>
        </div>
        <div className={classes.pointCard}>
          <div className={classes.pointIconWrapper}>
            <svg viewBox="0 0 24 24">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
            </svg>
          </div>
          <div className={classes.pointTitle}>שירות אישי</div>
          <div className={classes.pointText}>
            מקצועיות ואמינות לכל אורך הדרך.
          </div>
        </div>
        <div className={classes.pointCard}>
          <div className={classes.pointIconWrapper}>
            <svg viewBox="0 0 24 24">
              <path d="M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.06-.12L10.5 4h5l-1 7h4.5c.53 0 .54.34.35.63l-.06.1-8.29 9.27z" />
            </svg>
          </div>
          <div className={classes.pointTitle}>פתרונות מותאמים</div>
          <div className={classes.pointText}>
            לכל רכב לכל מקום לבית ולעסק.
          </div>
        </div>
      </div>
      <div
        className={classes.costumerRecommendation}
        id="customerRecommendation"
      >
        <div className={classes.sectionText4}>
          <div className={classes.top4}>
            <div className={classes.secondaryHeadline4}>לקוחות ממליצים</div>
          </div>
        </div>
      </div>
      <Carousel></Carousel>
      <div className={classes.ctaMiddle}>
        <div className={classes.see2}>
          <div className={classes.textContainer3}>
            <div className={classes.buttonText4}>
              <a href="https://wa.me/972522459908?text=%D7%94%D7%99%D7%99%20%D7%99%D7%95%D7%A1%D7%99%2C%20%D7%90%D7%A0%D7%99%20%D7%9E%D7%A2%D7%95%D7%A0%D7%99%D7%99%D7%9F%20%D7%91%D7%A2%D7%9E%D7%93%D7%AA%20%D7%98%D7%A2%D7%99%D7%A0%D7%94%20%D7%9C%D7%A8%D7%9B%D7%91%20%D7%97%D7%A9%D7%9E%D7%9C%D7%99">
                צור קשר
              </a>
            </div>
          </div>
        </div>
        <div className={classes.unnamed4}>
          רוצה להתחדש בעמדת טעינה? דבר איתי
        </div>
      </div>
      <div className={classes.gallery} id="ourWorks">
        <SectionText_AlignmentCenter
          className={classes.sectionText}
          classes={{ top: classes.top }}
          hide={{
            caption: true,
            mainHeadline: true,
            paragraph: true,
          }}
          text={{
            secondaryHeadline: (
              <div className={classes.secondaryHeadline}>עבודות שלי</div>
            ),
          }}
        />
        <div className={classes.frame1}>
          {[
            "WhatsApp Image 2026-05-14 at 7.54.56 PM.jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.30 PM (1).jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.30 PM.jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.31 PM (1).jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.31 PM.jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.32 PM (1).jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.32 PM.jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.33 PM (1).jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.33 PM (2).jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.33 PM.jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.35 PM (1).jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.35 PM (2).jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.35 PM.jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.36 PM.jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.37 PM (1).jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.37 PM (2).jpeg",
            "WhatsApp Image 2026-05-14 at 7.55.37 PM.jpeg",
            "image9211.jpg",
            "image921110.jpg",
            "image921113.jpg",
            "image92113.jpg"
          ].slice(0, showAllGallery ? undefined : 8).map((imgName, index) => {
            const isLast = !showAllGallery && index === 7;
            return (
              <div className={`${classes.contentBox} ${isLast ? classes.showMoreOverlay : ''}`} key={index}>
                <img
                  className={classes.image}
                  src={`collection/${imgName}`}
                  alt={`Image ${index + 1}`}
                />
                {isLast && (
                  <button 
                    className={classes.showMoreBtn} 
                    onClick={() => setShowAllGallery(true)}
                  >
                    <div className={classes.plusCircle}>+</div>
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div className={classes.companiesLogos}>
        <SectionText_AlignmentCenter
          className={classes.sectionText2}
          classes={{ top: classes.top2 }}
          hide={{
            caption: true,
            mainHeadline: true,
            paragraph: true,
          }}
          text={{
            secondaryHeadline: (
              <div className={classes.secondaryHeadline2}>
                אני מתקין עמדות של כל החברות המובילות בשוק
              </div>
            ),
          }}
        />
        <div className={classes.row3}>
          <div className={`${classes.iconEach} ${classes.circleIcon}`}>
            <img src="assets/tesla-logo.jpg" alt="Icon 1" />
          </div>
          <div className={`${classes.iconEach} ${classes.circleIcon}`}>
            <img src="assets/geely-logo.jpg" alt="Icon 2" />
          </div>
          <div className={`${classes.iconEach} ${classes.circleIcon}`}>
            <img src="assets/byd-logo.jpeg" alt="Icon 3" />
          </div>
        </div>
        <SectionText_AlignmentCenter
          className={classes.sectionText2}
          classes={{ top: classes.top2 }}
          hide={{
            caption: true,
            mainHeadline: true,
            paragraph: true,
          }}
          text={{
            secondaryHeadline: (
              <div className={classes.secondaryHeadline2} dir="rtl">
                ועוד...
              </div>
            ),
          }}
        />
      </div>
      <div className={classes.cta}>
        <div className={classes.frame7}>
          <div className={classes.frame15}>
            <div className={classes.unnamed5}>
              רוצה להתקין עמדת טעינה? השאר פרטים כאן
            </div>
          </div>
          <div ref={ctaRef}>
            <a
              ref={whatsappButtonRef}
              href="https://wa.me/972522459908?text=%D7%94%D7%99%D7%99%20%D7%99%D7%95%D7%A1%D7%99%2C%20%D7%90%D7%A0%D7%99%20%D7%9E%D7%A2%D7%95%D7%A0%D7%99%D7%99%D7%9F%20%D7%91%D7%A2%D7%9E%D7%93%D7%AA%20%D7%98%D7%A2%D7%99%D7%A0%D7%94%20%D7%9C%D7%A8%D7%9B%D7%91%20%D7%97%D7%A9%D7%9E%D7%9C%D7%99"
              target="_blank"
              className={
                buttonPositionFixed
                  ? classes.whatsappButton
                  : classes.whatsappButtonRelative
              }
            >
              <span className={classes.whatsappIcon}></span>
              <p dir="rtl">אני רוצה עמדת טעינה!</p>
            </a>
          </div>
        </div>
      </div>
      <Footer />
      <div className={classes.emptyDiv} ref={emptyDivRef}></div>
    </div>
  );
});
